import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { AuthContext } from '../../../contexts/AuthContext';
import Sidebar from '../../../layouts/global/dashboard/Sidebar';
import TopHeader from '../../../layouts/global/dashboard/TopHeader';
import axios from 'axios';
import WalletDetailCard from '../../../layouts/wallet/WalletDetailCard';
import AllFundTransactions from '../../../layouts/wallet/AllFundTransactions';
import WalletTopCard from '../../../layouts/wallet/WalletTopCard';
import PageTitle from '../../../layouts/global/dashboard/PageTitle';

export default function Wallet() {
  const { state } = useContext(AuthContext);

  const [transactions, setTransactions] = useState([]);
  const [wallet, setWallet] = useState(null);

  const token = localStorage.getItem('token');

  const loadWallet = async () => {
    const response = await axios.get(
      'https://secret-ridge-31139.herokuapp.com/api/auth/user-profile',
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return setWallet(response.data.wallet);
  };
  const loadTransactions = async () => {
    const response = await axios.get(
      'https://secret-ridge-31139.herokuapp.com/api/all_transactions',
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return setTransactions(response.data.data);
  };

  useEffect(() => {
    loadWallet();
    loadTransactions();
  }, []);

  return (
    <div>
      {state.isAuth ? (
        <Redirect to="/dashboard/wallet" />
      ) : (
        <Redirect to="/login" />
      )}
      <main className={'flex flex-col lg:flex-row'}>
        <Sidebar />
        <TopHeader />
        <section className={'lg:w-full bg-gray-100 h-auto min-h-screen'}>
          <div
            className={
              'w-full px-5 lg:pl-72 pt-20 lg:pt-16 lg:pr-10 bg-gray-100'
            }
          >
            <PageTitle title={'Wallet'} />
            <div className={'w-full flex flex-col lg:flex-row lg:items-start'}>
              <div className={'p-2 w-full lg:w-1/2'}>
                <WalletDetailCard wallet={wallet} />
              </div>
              <div className={'p-2 w-full lg:w-1/2'}>
                <WalletTopCard wallet={wallet} />
              </div>
            </div>
            <div className={'p-2'}>
              <div className={'p-5 shadow bg-white w-full mt-5'}>
                <div className={'mb-3'}>
                  <h3 className={'font-medium text-lg text-yellow-500'}>
                    All Fund Transactions
                  </h3>
                </div>
                <AllFundTransactions transactions={transactions} />
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
